<svg
    width="21"
    height="36"
    viewBox="0 0 21 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
        d="M18.9992 1.99414L2.99841 17.9949L18.9992 33.9957"
        stroke="#1D53A4"
        stroke-width="4"
        stroke-linecap="round" />
</svg>
